import * as S from "./ShipMonitoringCard.style";
import { ReactComponent as ImgShipAbove } from "../../../styles/assets/svg/icon_ship_up.svg";
import { ReactComponent as ImgShipPitch } from "../../../styles/assets/svg/icon_ship_pitch.svg";
import { ReactComponent as ImgShipRolling } from "../../../styles/assets/svg/icon_ship_rolling.svg";
import { ReactComponent as IconDirection } from "../../../styles/assets/svg/icon_ship_arrow.svg";
import { ShipOperationStatus } from "../../../common/types/ship";
import { formatDisplay } from "../../../common/functions/format";

interface ShipMonitoringCardProps {
  shipOperationStatus?: ShipOperationStatus;
}
export const ShipMonitoringCard = ({
  shipOperationStatus,
}: ShipMonitoringCardProps) => {
  return (
    <S.ShipMonitoringCardItem>
      <S.ShipMonitoringCard>
        <S.ShipCardContent>
          <div>
            15˚N24'15"
            {/* {formatDisplay(shipOperationStatus?.dashboard14)}kn */}
            <span>Latitude</span>
          </div>
          <div>
            {/* {formatDisplay(shipOperationStatus?.dashboard15)} */}
            30˚E10'3"<span>Longitude</span>
          </div>
        </S.ShipCardContent>
      </S.ShipMonitoringCard>

      <S.ShipMonitoringCard>
        <S.ShipCardGraphicBox>
          <S.ShipCardTitle>Wind</S.ShipCardTitle>
          <S.ShipCardGraphic>
            <IconDirection
              className="icon_direction"
              width={130}
              height={130}
              transform={`rotate(${shipOperationStatus?.dashboard16 ?? 0})`}
            />
            <ImgShipAbove />
          </S.ShipCardGraphic>
        </S.ShipCardGraphicBox>

        <S.ShipCardContent>
          <div>
            {formatDisplay(shipOperationStatus?.dashboard17)}kn
            <span>SOG</span>
          </div>
          <div>
            {formatDisplay(shipOperationStatus?.dashboard18)}˚
            <span>Direction</span>
          </div>
        </S.ShipCardContent>
      </S.ShipMonitoringCard>
    </S.ShipMonitoringCardItem>
  );
};
